import { Form, FormikProps } from 'formik';
import { useEffect } from 'react';
import { Grid } from '@mui/material';
import { CommonButtonWrapper, PageContent } from '@styles/CommonStyles';
import { FormPart } from '@modules/shared/components/FormPart';
import { CheckboxField } from '@shared/fields/CheckboxField';
import { PageWrapper } from '@shared/styledComponents';
import { IFormFieldConfig } from '@shared/components/FormFieldsConstructor';
import { TextEditorField } from '@shared/fields/TextEditorField';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { getOptions } from '@shared/commonFunctions';
import { CancelButton, SaveButton } from '@shared/inputs/Buttons';
import { SelectAutocompleteField } from '@shared/fields/SelectAutocompleteField';
import { IIStateRegulationFormModel } from './interfaces';
import { yesNoNotApplicableOptions } from './StateRegulationModal';

const getSelectProps = (name: string, label: string) => ({
  label,
  name,
  component: SelectAutocompleteField,
  hideNoneOption: true,
  options: getOptions(yesNoNotApplicableOptions, 'id', 'id'),
  width: '50%',
});

const getTextEditorProps = (name: string, label: string) => ({
  name,
  label,
  component: TextEditorField,
  width: '100%',
});

interface IStateRegulationFormProps extends FormikProps<IIStateRegulationFormModel> {
  onClose: () => void;
}

export const StateRegulationForm = ({ onClose, isSubmitting, errors }: IStateRegulationFormProps) => {
  const statusesConfig: IFormFieldConfig[] = [
    getSelectProps('notaryRequiredStatus', 'Notary Required'),
    getSelectProps('sorRequiredStatus', 'SOR Required Status'),
    getSelectProps('titleHoldingStatus', 'Title Holding Status'),
    getSelectProps('isOutOfStateTitleAllowed', 'Out of State Title Allowed'),
    getSelectProps('dropStatus', 'Drop Status'),
    getSelectProps('addStatus', 'Add Status'),
  ];

  const editorsConfig: IFormFieldConfig[] = [
    getTextEditorProps('salesTaxInformation', 'Sales Tax Information'),
    getTextEditorProps('specificRequirements', 'Specific Requirements'),
    getTextEditorProps('titleDocuments', 'Title Documents'),
  ];

  const formConfig: IFormFieldConfig[] = [
    {
      disabled: true,
      label: 'State',
      name: 'state',
      width: '100%',
    },
    ...statusesConfig,
    {
      component: CheckboxField,
      label: 'Allow Product and Sales Tax',
      name: 'isAllowProductAndSalesTax',
      width: '100%',
    },
    ...editorsConfig,
  ];

  useEffect(() => {
    if (isSubmitting && Object.keys(errors)?.length) {
      Notistack.generalError('Please fill all required fields');
    }
  }, [isSubmitting]);

  return (
    <Form>
      <PageWrapper>
        <PageContent>
          <Grid container spacing={12}>
            <Grid item md={12}>
              <FormPart config={formConfig} />
            </Grid>
          </Grid>
          <CommonButtonWrapper direction="row" paddingBottom="20px">
            <CancelButton onClick={onClose} />
            <SaveButton />
          </CommonButtonWrapper>
        </PageContent>
      </PageWrapper>
    </Form>
  );
};
